import React from 'react';

const PUB_URL = process.env.PUB_URL;

/*  eslint-disable jsx-a11y/href-no-hash */
const Footer = () => (
    <div className="container container-fixed-lg footer">
        <div className="copyright sm-text-center">
            <div className="small no-margin pull-left sm-pull-reset">
                <span className="hint-text">Copyright &copy; 2019</span>&nbsp;
                <span className="font-montserrat">budgetti.app</span>&nbsp;
                <span className="hint-text">All rights reserved. </span>
                <span className="sm-block">
                    <a href={`${PUB_URL}/terms`}
                       target="_blank"
                       className="m-l-10 m-r-10"
                       rel="noopener noreferrer"
                    >
                        Terms of use
                    </a>
                    <span className="muted">|</span>
                    <a href={`${PUB_URL}/privacy`}
                       target="_blank"
                       className="m-l-10"
                       rel="noopener noreferrer"
                    >
                        Privacy Policy
                    </a>
                </span>
            </div>
        </div>
    </div>
);

export default Footer;


// WEBPACK FOOTER //
// ./src/components/base/secure/footer/footer.js